<div class="dropdown-container" id="{{id}}" [ngClass]="{'unpositioned': floatOnMobile, 'disabled': disabled, 'isRelative': isRelative}">
  
  <div class="dropdown-button" (click)="changeValue()" [ngClass]="{'new-height': newHeight}">
    <div *ngIf="color" class="display-color" [ngClass]="{'green': color === 'green', 'red': color === 'red', 'yellow': color === 'yellow'}"></div>  
    <div class="left-container">
      <img *ngIf="icon" src="../../../../assets/svgs/{{icon}}.svg" alt="{{label}}">
      <p class="dropdown-title">{{label}}</p>
    </div>
    <div class="svg-div">
      <img src="../../../../assets/svgs/dropdown_arrow_ico.svg" [ngClass]="{'icon-revert': isOpen && !disabled}" label="arrow-icon" alt="dropdown-arrow">
    </div>   
  </div>
  <div class="dropdown-box" [ngClass]="{'align-right': alignRight, 'mobile-float': floatOnMobile}" *ngIf="isOpen && !disabled">
    <ng-content></ng-content>
  </div>
</div>
